import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const ConfirmInboundDeliveryQuantitiesMutation = graphql(/* GraphQL */ `
  mutation confirmInboundDeliveryQuantities(
    $confirmQuantitiesInput: ConfirmInboundDeliveryQuantitiesInput!
  ) {
    confirmInboundDeliveryQuantities(input: $confirmQuantitiesInput) {
      inboundDeliveryDetail {
        id
      }
    }
  }
`);
